"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginHelperServiceImpl = void 0;
var Types_1 = require("../../Types");
var core_1 = require("@athena-portal/core");
var moment = require("moment");
var rxjs_1 = require("rxjs");
var core_2 = require("@athena-portal/core");
var operators_1 = require("rxjs/operators");
var PluginHelperServiceImpl = exports.PluginHelperServiceImpl = /** @class */ (function () {
    function PluginHelperServiceImpl() {
    }
    PluginHelperServiceImpl.prototype.getActiveTempDriversInfoFromPolicyHistory = function (currentPolicies) {
        var promisses = [];
        var POLICY_STATUS_MTA = "MTA";
        var activePolicyHistoryList = [];
        for (var _i = 0, currentPolicies_1 = currentPolicies; _i < currentPolicies_1.length; _i++) {
            var currentPolicy = currentPolicies_1[_i];
            if (currentPolicy.policyHistoryList) {
                activePolicyHistoryList = __spreadArray(__spreadArray([], activePolicyHistoryList, true), currentPolicy.policyHistoryList.filter(function (ph) { return moment(ph.endDate).isAfter(moment()); }), true);
            }
        }
        var _loop_1 = function (currentPolicy) {
            if (activePolicyHistoryList && activePolicyHistoryList.length !== 0) {
                var currentActivePolicyHistoryList = activePolicyHistoryList.filter(function (ph) { return currentPolicy.interaction.agreementVersionId >= ph.id; });
                currentActivePolicyHistoryList.sort(function (b, a) { return a.number - b.number; });
                var policyVersionIds = [];
                for (var _b = 0, currentActivePolicyHistoryList_1 = currentActivePolicyHistoryList; _b < currentActivePolicyHistoryList_1.length; _b++) {
                    var activePolicyHistory = currentActivePolicyHistoryList_1[_b];
                    if (activePolicyHistory.status === POLICY_STATUS_MTA) {
                        policyVersionIds.push(activePolicyHistory.id);
                    }
                    else
                        break;
                }
                if (policyVersionIds) {
                    for (var _c = 0, policyVersionIds_1 = policyVersionIds; _c < policyVersionIds_1.length; _c++) {
                        var id = policyVersionIds_1[_c];
                        promisses.push(this_1.customerPortalService.getPoliciesByPolicyVersionId(id).pipe((0, operators_1.map)(function (policy) {
                            return {
                                policy: policy,
                                currentPolicy: currentPolicy
                            };
                        })).toPromise());
                    }
                }
            }
        };
        var this_1 = this;
        for (var _a = 0, currentPolicies_2 = currentPolicies; _a < currentPolicies_2.length; _a++) {
            var currentPolicy = currentPolicies_2[_a];
            _loop_1(currentPolicy);
        }
        return (0, rxjs_1.from)(Promise.all(promisses).then(function (policyMap) {
            var tempDrivers = new Map();
            policyMap.forEach(function (pol) {
                if (pol.policy && pol.policy.interaction && pol.policy.interaction.temporaryDrivers) {
                    var tempDriver = pol.policy.interaction.temporaryDrivers[0];
                    for (var _i = 0, _a = pol.policy.interaction.vehicles; _i < _a.length; _i++) {
                        var mtaVehicle = _a[_i];
                        for (var _b = 0, _c = pol.currentPolicy.interaction.vehicles; _b < _c.length; _b++) {
                            var vehicle = _c[_b];
                            if (vehicle.registrationNumber === mtaVehicle.registrationNumber && mtaVehicle.driverIds.includes(tempDriver.personId)) {
                                tempDriver.mainDriver = mtaVehicle.mainDriverId === tempDriver.personId ? true : false;
                                tempDrivers.set(vehicle.registrationNumber, tempDriver);
                            }
                        }
                    }
                }
            });
            return tempDrivers;
        }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], PluginHelperServiceImpl.prototype, "customerPortalService", void 0);
    PluginHelperServiceImpl = __decorate([
        (0, core_2.injectable)()
    ], PluginHelperServiceImpl);
    return PluginHelperServiceImpl;
}());
//# sourceMappingURL=PluginHelperServiceImpl.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/services/impl/PluginHelperServiceImpl.js
// module id = 2480
// module chunks = 0